// extracted by mini-css-extract-plugin
var _1 = "Z6wXM";
var _2 = "AzvOw";
var _3 = "yeVMh";
var _4 = "uIhB7";
var _5 = "CMkEI";
export { _1 as "addColumnButton", _2 as "addNewColumnInfo", _3 as "column", _4 as "defaultValue", _5 as "typeSelector" }
